(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraiserLenderChangesReportController', AppraiserLenderChangesReportController);

    AppraiserLenderChangesReportController.$inject = [
        '$http', '$state', '$stateParams', 'AlertService', 'paginationConstants', 'ParseLinks'
    ];

    function AppraiserLenderChangesReportController($http, $state, $stateParams, AlertService, paginationConstants, ParseLinks) {
        var vm = this;

        vm.search = $stateParams.search || '';
        vm.rows = [];
        vm.loading = false;
        vm.page = 1;
        vm.totalItems = 0;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.load = load;
        vm.submit = submit;
        vm.reset = reset;
        vm.onPageChange = onPageChange;
        vm.openUser = openUser;
        vm.toggleRowExpand = toggleRowExpand;
        vm.pipeList = pipeList;

        load();

        function submit() {
            vm.page = 1;
            load();
        }

        function load() {
            vm.loading = true;
            $state.go('report.appraiser-lender-changes',
                { search: vm.search || null },
                { location: 'replace', notify: false }
            );
            var params = {
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: 'changedAt,desc'
            };
            if (vm.search && vm.search.trim().length > 0) {
                params.search = vm.search.trim();
            }
            $http.get('api/reports/appraiser-lender-changes', { params: params })
                .then(function(response) {
                    ParseLinks.parse(response.headers('link'));
                    vm.totalItems = response.headers('X-Total-Count');
                    vm.rows = response.data;
                })
                .catch(function() {
                    AlertService.error('Error loading report.');
                })
                .finally(function() {
                    vm.loading = false;
                });
        }

        function reset() {
            vm.search = '';
            vm.page = 1;
            $state.go('report.appraiser-lender-changes',
                { search: null },
                { location: 'replace', notify: false }
            );
            load();
        }

        function onPageChange() {
            load();
        }

        function pipeList(pipeDelimited) {
            if (!pipeDelimited || typeof pipeDelimited !== 'string') {
                return [];
            }
            return pipeDelimited.split('|').map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; });
        }

        function toggleRowExpand($event, row) {
            $event.stopPropagation();
            row._expanded = !row._expanded;
        }

        function openUser(row) {
            if (!row || !row.appraiserLogin) {
                return;
            }
            var url = $state.href('user-management.edit', { login: row.appraiserLogin }, { absolute: true });
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }
})();
